export default __webpack_public_path__ + "static/media/faq_img.3e64c36d.svg";